
<pfm-download-portfolio-modal [(portfolio)]="downloadPortfolio"></pfm-download-portfolio-modal>

<frame-default [status]="status" errorMessage="Beim Laden der Portfolios ist ein Fehler aufgetreten">
  <main>
    <pfm-breadcrumbs style="align-self: start; margin-bottom: 1rem;"
                     [crumbs]="[{text:'Seiten'}, {text:'Portfolios', link: '/portfolios/list', active: true},]" ></pfm-breadcrumbs>


    <div class="statistics">
      <pfm-statistics-text icon="file-pen" title="Portfolios insgesamt" [loading]="portfolioTotalCount === null" [value]="portfolioTotalCount ?? '...'"></pfm-statistics-text>
      <div class="spacer"></div>
      <pfm-button routerLink="/portfolios/create" icon="plus">Portfolio anlegen</pfm-button>
    </div>

    <pfm-input class="searchfield"
               [preIcon]="['fas', 'magnifying-glass']"
               placeholder="Tabelle durchsuchen"
               [value]="(filters['search'].active ?? '') | caststring"
               [autoTrim]="false"
               (valueChange)="filters['search'].active = $event; searchObservable?.next($event)"></pfm-input>

    <pfm-card header="Portfolios">

      <pfm-table [datasource]="portfolios" [hoverHighlight]="true">

        <pfm-table-col header="Name">
          <ng-template [ctxType]="{item:portfolios[0]!}" let-item="item">{{item.name}}</ng-template>
        </pfm-table-col>

        <pfm-table-col header="Template">
          <ng-template [ctxType]="{item:portfolios[0]!}" let-item="item">{{translateTemplate(item.template)}}</ng-template>
        </pfm-table-col>

        <pfm-table-col header="">
          <ng-template [ctxType]="{item:portfolios[0]!}" let-item="item">
            <pfm-context-menu>
              <pfm-context-menu-item [icon]="['fat', 'pen']"                  (onClick)="editPortfolio(item)"     >Bearbeiten</pfm-context-menu-item>
              <pfm-context-menu-item [icon]="['fat', 'arrow-down-to-square']" (onClick)="downloadPortfolio=item"  >Download</pfm-context-menu-item>
              <pfm-context-menu-item [icon]="['fat', 'trash-can']"            (onClick)="deletePortfolio(item)"   >Löschen</pfm-context-menu-item>
            </pfm-context-menu>
          </ng-template>
        </pfm-table-col>

      </pfm-table>
    </pfm-card>
  </main>
</frame-default>
